window.customElements.define("ua-breadcrumbs", class UABreadcrumbs extends HTMLElement {

  constructor() {
    super();

    this.localStorageKey = 'ua-breadcrumbs';

    window.addEventListener('DOMContentLoaded', () => {
      
      const isProductPage = window.location.href.includes('/products/');
      if (isProductPage) {
        const previousURL = document.referrer;
        if (previousURL && previousURL.includes('/collections/')) {
          this.addCollectionBreadcrumb();
        }else{
          this.removePreviousBreadcrumbs();
        }
      }

      document.querySelectorAll('a[href*="/products/"]').forEach((item) => {
        item.addEventListener('click', (event) => {
          localStorage.removeItem(this.localStorageKey);
          console.log(localStorage.getItem('ua-breadcrumbs'))
        });
      });

      document.querySelectorAll('#product-grid a[href*="/products/"]').forEach((item) => {
        removeEventListener('click', this);
        item.addEventListener('click', (event) => {
          this.saveBreadcrumbs();
          console.log(localStorage.getItem('ua-breadcrumbs'))
        });
      });


    });
    
  }


      removePreviousBreadcrumbs() {
        localStorage.removeItem(this.localStorageKey);
      }

      saveBreadcrumbs() {

        const currentURL = window.location.href;
        const pageTitle = this.cleanTitle(document.querySelector('h1')?.textContent || '');

        console.log(currentURL)
    
        if (currentURL.includes('/collections/')) {
          this.removePreviousBreadcrumbs();
    
          const breadcrumbs = {
            collection: {
              title: pageTitle,
              url: currentURL,
            },
          };
    
          localStorage.setItem(this.localStorageKey, JSON.stringify(breadcrumbs));
        }
      }


      cleanTitle(title) {
        return title.replace(/[\r\n]+/g, '').replace(/^Collection:\s+/i, '').trim().replace(/Collection:\s+/i, '');
      }

  

      addCollectionBreadcrumb() {
        const previousCollection = localStorage.getItem('ua-breadcrumbs');
        if (previousCollection) {
          const breadcrumbs = JSON.parse(previousCollection);
          const { title, url } = breadcrumbs.collection;
          if (title && url) {
            const ulElement = this.querySelector('ul, ol');
    
            if (ulElement) {
              const previousURL = document.referrer;
    
              if (previousURL && previousURL.includes('/products/')) {
                // Don't add the element if the previous URL has 'products' in it
                return;
              }

              const firstLiElement = ulElement.querySelector('li:first-child');
              const liElement = document.createElement('li');
              const aElement = document.createElement('a');
              const aElementSpan = document.createElement('span');
              const aElementMeta = document.createElement('meta');

              liElement.setAttribute("itemprop", "itemListElement");
              liElement.setAttribute("itemscope", "");
              liElement.setAttribute("itemtype", "https://schema.org/ListItem")
              aElementMeta.setAttribute("itemprop", "position");
              aElement.setAttribute("itemprop", "item");
              aElementSpan.setAttribute("itemprop", "name");

              ulElement.querySelector('meta[content="2"]').setAttribute('content', '3');
              aElementMeta.setAttribute('content', '2');

              aElement.href = url;
              aElement.classList.add('link', 'link--text', 'list-menu__item', 'list-menu__item--link');
              aElementSpan.textContent = title;
            
              if (firstLiElement) {
                ulElement.insertBefore(liElement, firstLiElement.nextSibling);
              } else {
                ulElement.appendChild(liElement);
                aElementMeta.setAttribute('content', '1');
              }

              aElement.appendChild(aElementSpan);
              liElement.appendChild(aElement);
              liElement.appendChild(aElementMeta);

            }
            
          }
        }
      }
})